export interface IAuthState {
	auth: boolean
	accessToken: string | null
	mfaRequiredError: null | string
	mfaRequiredErrorDescription: null | string
	mfaToken: string | null
	loading: boolean
	authenticators: Array<IMfaAuthenticator>
	oobChannel: string
	oobCode: string
	skipMfa: boolean
}

export type OobChannelType = 'sms' | 'voice'

interface IMfaError {
	mfaRequiredError: string | null
	mfaRequiredErrorDescription: string | null
}

// authenticators

export interface IMfaAuthenticator {
	active: boolean
	['authenticator_type']: string
	id: string
	name?: string
	['oob_channel']?: string
	['oob_code']?: string
}

// action interfaces

export enum AuthActionTypes {
	AUTH_LOGIN = 'AUTH_LOGIN',
	AUTH_MFA_REQUIRED_ERROR = 'AUTH_MFA_REQUIRED_ERROR',
	AUTH_LOADING = 'AUTH_LOADING',
	AUTH_SET_MFA_TOKEN = 'AUTH_SET_MFA_TOKEN',
	AUTH_SET_AUTHENTICATORS = 'AUTH_SET_AUTHENTICATORS',
	AUTH_SET_OOB_CHANNEL = 'AUTH_SET_OOB_CHANNEL',
	AUTH_SET_OOB_CODE = 'AUTH_SET_OOB_CODE',
	AUTH_REGISTER_AUTHENTICATOR = 'AUTH_REGISTER_AUTHENTICATOR',
	AUTH_SET_SKIP_MFA_AUTH = 'AUTH_SET_SKIP_MFA_AUTH',
	AUTH_RESET_STORE = 'AUTH_RESET_STORE',
}

interface IAuthLoginInAction {
	type: AuthActionTypes.AUTH_LOGIN
	payload: string
}

interface IAuthMfaErrorAction {
	type: AuthActionTypes.AUTH_MFA_REQUIRED_ERROR
	payload: IMfaError
}

interface IAuthLoadingAction {
	type: AuthActionTypes.AUTH_LOADING
	payload: boolean
}

interface IAuthSetMFATokenAction {
	type: AuthActionTypes.AUTH_SET_MFA_TOKEN
	payload: string
}

export interface IAuthSetAuthenticatorsAction {
	type: AuthActionTypes.AUTH_SET_AUTHENTICATORS
	payload: Array<IMfaAuthenticator>
}

export interface IAuthSetMfaOOBChannelAction {
	type: AuthActionTypes.AUTH_SET_OOB_CHANNEL
	payload: string
}

interface IAuthSetMfaOOBCodeAction {
	type: AuthActionTypes.AUTH_SET_OOB_CODE
	payload: string
}

interface IAuthRegisterAuthenticator {
	type: AuthActionTypes.AUTH_REGISTER_AUTHENTICATOR
	payload: string
}

export interface IAuthSetSkipMfa {
	type: AuthActionTypes.AUTH_SET_SKIP_MFA_AUTH
	payload: boolean
}

interface IAuthResetStore {
	type: AuthActionTypes.AUTH_RESET_STORE
}

export type AuthAction =
	| IAuthLoginInAction
	| IAuthMfaErrorAction
	| IAuthLoadingAction
	| IAuthSetMfaOOBChannelAction
	| IAuthSetAuthenticatorsAction
	| IAuthSetMFATokenAction
	| IAuthSetMfaOOBCodeAction
	| IAuthRegisterAuthenticator
	| IAuthSetSkipMfa
	| IAuthResetStore

// auth responses

export interface IMfaChallengeResponse {
	['challenge_type']: string
	['oob_code']: string
	['binding_method']: string
}

export interface ICompleteAuthenticationResponse {
	['id_token']: string
	['access_token']: string
	['expires_in']: number
	['scope']: string
	['token_type']: string
}
